import apiClient from '../utilities/apiClient.utility';

const programUrl = `${window.config.CONNECT_URLS.programs}`;


// export const getEducationalReferenceList = async ({program_id})=>{
//     alert(programUrl)
//     return await apiClient.get(
//         `${programUrl}/${program_id}/feed`
//     );

// }

// export const getEducationalReferenceById = async ({program_id,feed_id})=>{
//      console.log('Calling API with:', program_id, feed_id);
//   return await apiClient.get(
//         `${programUrl}/${program_id}/feed/${feed_id}`
//     );
// }

export const createEducationalReference = async ({program_id,payload })=>{
return await apiClient.post(
    `${programUrl}/${program_id}/dashboard/feed`,payload
)

}

export const updateEducationalReference = async ({program_id,feed_id,payload })=>{
return await apiClient.patch(
`${programUrl}/${program_id}/dashboard/feed/${feed_id}`,payload
)

}

export const DeleteEducationalReference = async ({program_id,feed_id })=>{
      if (!program_id || !feed_id) {
    throw new Error("Missing program_id or feed_id in delete call");
  }

return await apiClient.del(
    `${programUrl}/${program_id}/dashboard/feed/${feed_id}`
)

}